import { addHours, format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { Theme, useMediaQuery } from '@mui/material'

import Chip from '../common/chip'
import { numberWithCommas } from '../../utils'
import { CustomerCompanyFunding } from '../../types'
import CalendarIcon from '../../assets/icons/calendar-icon.svg'
import DocumentIcon from '../../assets/icons/document-icon.svg'
import MoneyGreenIcon from '../../assets/icons/money-icon-green.svg'
import ArrowRightIcon from '../../assets/icons/arrow-right-icon.svg'
import { countriesCurrencies } from '../../lib'

const CustomerCompanyFundingDataListItem = ({
  customerCompanyFundingData,
  handleOpenCustomerCompanyFundingDetailsModal
}: {
  customerCompanyFundingData: CustomerCompanyFunding
  handleOpenCustomerCompanyFundingDetailsModal: (customerCompanyFunding: CustomerCompanyFunding) => void
}) => {
  const { t } = useTranslation(['customer-company-details-management'])
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'))

  const selectedCountry = globalThis.sessionStorage.getItem('selectedCountry') || 'COL'

  return (
    <div
      className="payment-list-item-data-container"
      onClick={() => handleOpenCustomerCompanyFundingDetailsModal(customerCompanyFundingData)}
    >
      <div className="payment-list-item-data-left-container funding-list-item-left-container width-70-sm">
        {mdUp && (
          <div className="left-content">
            <div className="users-management-user-image-profile">
              <img
                src={CalendarIcon}
                alt="calendar-icon"
              />
            </div>
            <div className="users-management-user-name-profile">{format(addHours(new Date(customerCompanyFundingData.createdAt), 5), 'dd/MM/yyyy')}</div>
          </div>
        )}
        <div
          className="right-content justify-content-flex-start gap-8 flex-direction-row-sm"
          style={{ justifyContent: 'start' }}
        >
          <div className="users-management-user-image-profile">
            <img
              src={MoneyGreenIcon}
              alt="money-icon"
            />
          </div>
          <div className="users-management-user-name-profile">
            {Number(customerCompanyFundingData.fundingSaleRate) > 0
              ? `$ ${numberWithCommas(Math.round(Number(customerCompanyFundingData.fundingSaleQuantity * customerCompanyFundingData.fundingSaleRate)))} ${
                  (countriesCurrencies as { [key: string]: string })[selectedCountry]
                }`
              : `$ ${numberWithCommas(Math.round(Number(customerCompanyFundingData.purchaseNetValueResult)))} ${(countriesCurrencies as { [key: string]: string })[selectedCountry]}`}
          </div>
        </div>
      </div>
      <div className="payment-list-item-data-right-container funding-list-item-right-container gap-10 justify-content-start width-30-sm">
        <div className="left-content width-70">
          {customerCompanyFundingData.description ? (
            <div className="full-width display-flex display-none-995">
              <div className="users-management-user-image-profile">
                <img
                  src={DocumentIcon}
                  alt="document-icon"
                />
              </div>
              <div className="users-management-user-name-profile max-width-450">{customerCompanyFundingData.description.replace(/\n/g, ' ')}</div>
            </div>
          ) : (
            <div className="full-width display-flex display-none-995">
              <div className="users-management-user-image-profile">
                <img
                  src={DocumentIcon}
                  alt="document-icon"
                />
              </div>
              <div className="users-management-user-name-profile max-width-450">-</div>
            </div>
          )}
        </div>
        <div
          style={{ justifyContent: 'space-between' }}
          className="right-content flex-direction-row-sm width-30"
        >
          <div className="funding-list-item-data-status">
            <Chip
              status={customerCompanyFundingData.status}
              label={
                customerCompanyFundingData.status === 'processing'
                  ? t('fundingStatus.processing')
                  : customerCompanyFundingData.status === 'pending-credit'
                  ? t('fundingStatus.pending-credit')
                  : customerCompanyFundingData.status === 'rejected'
                  ? t('fundingStatus.rejected')
                  : customerCompanyFundingData.status === 'reverted'
                  ? t('fundingStatus.reverted')
                  : t('fundingStatus.approved')
              }
            />
          </div>
          <img
            src={ArrowRightIcon}
            alt="arrow-right-icon"
          />
        </div>
      </div>
    </div>
  )
}

export default CustomerCompanyFundingDataListItem
